import { render, staticRenderFns } from "./product-title-block.vue?vue&type=template&id=3ae7f9c6&"
import script from "./product-title-block.vue?vue&type=script&lang=js&"
export * from "./product-title-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports